import { http, httpV2 } from "@/api/index";

/**
* @summary Busca uma empresa atrávés do seu Id.
* @param {number} id - Id da empresa;
* @returns {Promise} A promise de uma empresa.
*/
const GetCompany = function(id)
{
	return http.get(`/Companies/${id}`);
};

/**
 * @summary Busca a árvore de monitoramento de uma empresa.
 * @param {number} id Id da empresa;
 * @returns {Promise} A promise de uma árvore de monitoramento.
 */
const GetWindMonitoringElementTree = function(id)
{
	return httpV2.get(`Companies/${id}/WindMonitoringElementTree`);
};

/**
 * @summary Busca o company que está utilizando a aplicação.
 * @param {number} id - Id da empresa;
 * @param {object} companyModel - Model de atualização da empresa.
 * @returns {Promise} Promise Empresa atualizada.
 */
const PutCompany = function(id, companyModel)
{
	return http.put(`/Companies/${id}`, companyModel);
};

/**
* @summary Busca todas as empresas do sistema.
* @returns {[{}]} - A promise de uma Lista de empresas.
*/
const GetCompanies = function()
{
	return http.get("Companies");
};

/**
* @summary Obtém as unidades geradoras de uma empresa.
* @param {number} companyId - Id da empresa;
* @returns {Promise} - A promise de uma Lista de unidades geradoras.
*/
const GetCompanyGeneratingUnits = function(companyId)
{
	return httpV2.get(`/Companies/${companyId}/GeneratingUnits`);
};

/**
 * @summary Obtém os e-mails associados a uma empresa específica.
 * @param {number} companyId - Id da empresa.
 * @returns {Promise} - A promise que resolve com uma lista de e-mails associados à empresa.
 */
const GetCompanyEmails = function(companyId)
{
	return httpV2.get(`/Companies/${companyId}/Emails`);
};

export default {
	GetCompanies,
	GetWindMonitoringElementTree,
	GetCompany,
	PutCompany,
	GetCompanyGeneratingUnits,
	GetCompanyEmails,
};